import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Divider } from "@mui/material";
import { observer } from "mobx-react-lite";
import { store } from "services/state";
import Loader from "components/Loader";

const defaultEnvs = [
  { text: "sit", url: "https://origin-dev.mts.maxapi.com.au/v1/docs" },
  { text: "uat", url: "https://origin-test.mts.maxapi.com.au/v1/docs" },
  { text: "prod", url: "https://origin-mts.maxapi.com.au/v1/docs" },
];

const Swagger = observer(() => {
  const envList = store.environmentList;
  const loading = envList.length === 0;

  const updatedEnvList = envList.map(({ text, ...rest }) => {
    const defaultEnv = defaultEnvs.find((env) => env.text === text);
    return {
      ...rest,
      text,
      url: defaultEnv
        ? defaultEnv.url
        : `https://origin-dev.mts.maxapi.com.au/${text}/v1/docs`,
    };
  });
  return (
    <>
      {loading ? (
       <Loader />
      ) : (
        <Box sx={{ p: 2 }}>
          <Typography variant="h5" sx={{ mb: 2 }}>
            API Documentation
          </Typography>
          <Divider sx={{ mb: 4 }} />
          <TableContainer component={Paper} sx={{ width: "30%" }}>
            <Table sx={{ width: "100%" }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Environment</b>
                  </TableCell>
                  <TableCell>
                    <b>Link</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {updatedEnvList.map((env) => (
                  <TableRow key={env.key}>
                    <TableCell sx={{ textTransform: "uppercase" }}>
                      {env.text}
                    </TableCell>
                    <TableCell>
                      <Button
                        disableElevation
                        variant="contained"
                        color="primary"
                        component="a"
                        href={env.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Open
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
});

export default Swagger;
